import { render, staticRenderFns } from "./AgentSettings.vue?vue&type=template&id=271ea23d"
import script from "./AgentSettings.vue?vue&type=script&lang=js"
export * from "./AgentSettings.vue?vue&type=script&lang=js"
import style0 from "./AgentSettings.vue?vue&type=style&index=0&id=271ea23d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports